export default __webpack_public_path__ + "static/media/DTproto3.fb960667.jpg";